import "./ChipList.css";
import classNames from "classnames";

interface ChipProps {
  className?: string;
  children?: React.ReactNode;
}

const ChipList: React.FC<ChipProps> = ({ children, className }) => (
  <div className={classNames("ChipList", className)}>{children}</div>
);
export default ChipList;
